import "./TeamCard.scss";

interface TeamCardProps {
  initial: string;
  name: string;
  role: string;
  bio: string;
  image?: string;
}

const TeamCard = ({ initial, name, role, bio, image }: TeamCardProps) => {
  return (
    <div className="teamCard">
      <div className="teamAvatar">
        {image ? <img src={image} alt={name} className="teamAvatarImg" /> : initial}
      </div>
      <div className="teamName">{name}</div>
      <div className="teamRole">{role}</div>
      <p className="teamBio">{bio}</p>
    </div>
  );
};

export default TeamCard;
